export let validationLength = (value) => {
    return value.length >= 2 && value.length <= 30;
}

export let validationMob = (value) => {
    return value.length >= 9;
}

export const validationMatch = (value, name) => {
    switch(name) {
        case 'password':
            return /[A-Z]/.test(value) && /[0-9]/.test(value) && /[$@$#!%*?&]/.test(value);
        case 'disp_name':
            return true;
        case 'email':
            return !!value &&
                value
                    .toLowerCase()
                    .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
                    );
        case 'username':
            return !/[" "]/.test(value);
        default:
            return true;
    }
}